export default __webpack_public_path__ + "static/media/slide2-sk.ce245804.jpg";